import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#ffffff",
  boxShadow:
    "0 8px 24px rgba(16,69,70,0.1), 0 20px 48px rgba(16,69,70,0.12)",
  border: "1px solid #E5E9EB",
  borderRadius: "18px",
  outline: "none",
  overflow: "hidden",
  height: "auto",
  maxHeight: "90vh",
  overflowY: "auto",
  maxWidth: "min(92vw, 720px)",
  width: "auto",
  minWidth: "min(92vw, 320px)",
};

export default function CustomModal({ open, setOpen, children }) {
  const handleClose = () => setOpen(false);
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 220,
          sx: {
            backgroundColor: "rgba(16,36,38,0.5)",
            backdropFilter: "blur(2px)",
          },
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>{children}</Box>
      </Fade>
    </Modal>
  );
}
